import React from "react";
import _ from "lodash";

import { PictureAsPdf } from "components/Icons";
import IColumn from "models/IColumn";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: rowData => (
      <PictureAsPdf
        id={`download-quality-report-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "InspectionReport")
          );
        }}
      />
    ),
    visible: true,
    notRowClick: true
  },
  {
    title: "REPORTS_NR",
    fixedWidth: 164,
    key: "BatchNumber",
    visible: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "ItemDescription",
    visible: true
  },
  {
    title: "SIZE",
    key: "Size",
    visible: true
  },
  {
    title: "DATE",
    key: "Date",
    type: "date",
    visible: true
  },
  {
    title: "REPORTS_TYPE",
    key: "TypeId",
    visible: true
  },
  {
    title: "INSPECTION_DATE",
    key: "ArrivalDate",
    type: "date",
    visible: true
  },
  {
    title: "RECEIPTS_SUPPLIER",
    key: "SupplierName",
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "OrderNumber",
    visible: true
  },
  {
    title: "INSPECTION_NR",
    key: "Number",
    visible: false
  }
];
